<mat-form-field *ngIf="model.additional.paperProcessOverride" data-test="gsm-schaden-angabe_beilage-field">
  <mat-label>Objekte erfassen?</mat-label>
  <mat-select
    [(ngModel)]="isSieheBeilage"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="model.disabled"
    (ngModelChange)="onSieheBeilageChange($event)"
    data-test="gsm-schaden-angabe_beilage-select"
  >
    <mat-option [value]="true">
      <span>Siehe Beilage</span>
    </mat-option>
    <mat-option [value]="false">
      <span>Geschädigte Objekte erfassen</span>
    </mat-option>
  </mat-select>
</mat-form-field>
<div class="schaden-angabe-container" [hidden]="isSieheBeilage" data-test="gsm-schaden-angabe_container">
  <ng-container *ngIf="!showForm">
    <form [formGroup]="group">
      <mat-tab-group
        [selectedIndex]="selectedTab.value"
        (selectedIndexChange)="selectedTab.setValue($event)"
        data-test="gsm-schaden-angabe_tabs"
      >
        <mat-tab *ngIf="showTab('kfz')" label="KFZ{{ getCategoryObjectCountLabel(kfzDataSource) }}">
          <table mat-table [dataSource]="kfzDataSource" class="mat-elevation">
            <!-- marke Column -->
            <ng-container matColumnDef="marke">
              <th mat-header-cell *matHeaderCellDef>Marke</th>
              <td mat-cell *matCellDef="let element">{{ element.marke?.label }}</td>
            </ng-container>

            <!-- modell Column -->
            <ng-container matColumnDef="modell">
              <th mat-header-cell *matHeaderCellDef>Modell</th>
              <td mat-cell *matCellDef="let element">{{ element.modell }}</td>
            </ng-container>

            <!-- kennzeichen Column -->
            <ng-container matColumnDef="kennzeichen">
              <th mat-header-cell *matHeaderCellDef>Kennzeichen</th>
              <td mat-cell *matCellDef="let element">{{ element.kennzeichen || 'Unbekannt' }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let element; let index = index">
                <button mat-icon-button (click)="editItem('kfz', element)" data-test="gsm-schaden-angabe_kfz-edit">
                  <mat-icon>{{ isFormDisabled ? 'visibility' : 'edit' }}</mat-icon>
                </button>
                <button mat-icon-button *ngIf="!isFormDisabled" (click)="removeItem(element)"
                        data-test="gsm-schaden-angabe_kfz-delete">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['marke', 'modell', 'kennzeichen', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['marke', 'modell', 'kennzeichen', 'actions']"></tr>
          </table>

          <div class="add-item" *ngIf="!isFormDisabled" (click)="setForm('kfz', null, true)"
               data-test="gsm-schaden-angabe_kfz-add">
            <button mat-mini-fab color="primary">
              <mat-icon>add</mat-icon>
            </button>
            <span class="label">KFZ hinzufügen</span>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showTab('sache')" label="Sache{{ getCategoryObjectCountLabel(sacheDataSource) }}">
          <table mat-table [dataSource]="sacheDataSource" class="mat-elevation">
            <!-- beschreibung Column -->
            <ng-container matColumnDef="beschreibung">
              <th mat-header-cell *matHeaderCellDef>Beschreibung</th>
              <td mat-cell *matCellDef="let element">{{ element.beschreibung }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let element; let index = index">
                <button mat-icon-button (click)="editItem('sache', element)" data-test="gsm-schaden-angabe_sache-edit">
                  <mat-icon>{{ isFormDisabled ? 'visibility' : 'edit' }}</mat-icon>
                </button>
                <button
                  mat-icon-button
                  *ngIf="!isFormDisabled"
                  (click)="removeItem(element, 'geschaedigteSacheList')"
                  data-test="gsm-schaden-angabe_sache-delete"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['beschreibung', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['beschreibung', 'actions']"></tr>
          </table>

          <div class="add-item" *ngIf="!isFormDisabled" (click)="setForm('sache', null, true)"
               data-test="gsm-schaden-angabe_sache-add">
            <button mat-mini-fab color="primary">
              <mat-icon>add</mat-icon>
            </button>
            <span class="label">Sache hinzufügen</span>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showTab('person')" label="Person{{ getCategoryObjectCountLabel(personDataSource) }}">
          <table mat-table [dataSource]="personDataSource" class="mat-elevation">
            <!-- name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">{{ element.vorname }} {{ element.nachname }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let element; let index = index">
                <button mat-icon-button (click)="editItem('person', element)"
                        data-test="gsm-schaden-angabe_person-edit">
                  <mat-icon>{{ isFormDisabled ? 'visibility' : 'edit' }}</mat-icon>
                </button>
                <button mat-icon-button *ngIf="!isFormDisabled" (click)="removeItem(element)"
                        data-test="gsm-schaden-angabe_person-delete">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['name', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['name', 'actions']"></tr>
          </table>

          <div class="add-item" *ngIf="!isFormDisabled" (click)="setForm('person', null, true)"
               data-test="gsm-schaden-angabe_person-add">
            <button mat-mini-fab color="primary">
              <mat-icon>add</mat-icon>
            </button>
            <span class="label">Person hinzufügen</span>
          </div>
        </mat-tab>
        <mat-tab *ngIf="showTab('tier')" label="Tier{{ getCategoryObjectCountLabel(tierDataSource) }}">
          <table mat-table [dataSource]="tierDataSource" class="mat-elevation">
            <!-- modell Column -->
            <ng-container matColumnDef="bezeichnung">
              <th mat-header-cell *matHeaderCellDef>Tiergattung</th>
              <td mat-cell *matCellDef="let element">{{ element.bezeichnung }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Aktionen</th>
              <td mat-cell *matCellDef="let element; let index = index">
                <button mat-icon-button (click)="editItem('tier', element)" data-test="gsm-schaden-angabe_tier-edit">
                  <mat-icon>{{ isFormDisabled ? 'visibility' : 'edit' }}</mat-icon>
                </button>
                <button
                  mat-icon-button
                  *ngIf="!isFormDisabled"
                  (click)="removeItem(element, 'geschaedigtesTierList')"
                  data-test="gsm-schaden-angabe_tier-delete"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['bezeichnung', 'actions']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['bezeichnung', 'actions']"></tr>
          </table>

          <div class="add-item" *ngIf="!isFormDisabled" (click)="setForm('tier', null, true)"
               data-test="gsm-schaden-angabe_tier-add">
            <button mat-mini-fab color="primary">
              <mat-icon>add</mat-icon>
            </button>
            <span class="label">Tier hinzufügen</span>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </ng-container>
  <ng-container *ngIf="showForm">
    <form [formGroup]="entryFormGroup">
      <dynamic-material-form
        [hidden]="isFormHidden"
        [group]="entryFormGroup"
        [model]="entryFormModel"
        data-test="gsm-schaden-angabe_entry-form"
      ></dynamic-material-form>
      <mat-checkbox
        *ngIf="selectedCategory === ''"
        class="unknown-person-checkbox"
        [(ngModel)]="isUnknownPerson"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="isFormDisabled"
        (ngModelChange)="onUnknownCheckboxChange($event)"
        data-test="gsm-schaden-angabe_unknown-person-cb"
      >
        Die Geschädigte Person ist unbekannt
      </mat-checkbox>
      <button mat-raised-button class="cancel-button" (click)="cancelEdit()" data-test="gsm-schaden-angabe_cancel-btn">
        {{ isFormDisabled ? 'Schließen' : 'Abbrechen' }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="gsm-schaden-angabe_save-btn"
        *ngIf="!isFormDisabled"
        [disabled]="!isEntryFormValid || isLoading"
        (click)="saveItem($event)"
        data-test="gsm-schaden-angabe_save-btn"
      >
        <span *ngIf="!isLoading">Speichern</span>
        <mat-spinner [diameter]="30" *ngIf="isLoading"></mat-spinner>
      </button>
    </form>
  </ng-container>
</div>
